import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../Context/AppContext';
import { RootState } from '../../../Redux/Store';
import { useAppSelector } from '../../../Hooks/Hooks';
import ProfileCircle from '../../../Components/Profile/ProfileCircle/ProfileCircle';
import ManageMenu from '../../../Components/ManageMenu/ManageMenu';
import './Manage.scss';

const Manage = () => {
  const navigate = useNavigate();
  const { isMobile } = useContext(AppContext);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const [isRolesShow, setRolesShow] = useState(false);

  useEffect(() => {
    if (!isMobile) navigate('/');
  }, [isMobile, navigate]);

  const toggleRoles = () => {
    setRolesShow(!isRolesShow);
  };

  const mockRoles = ['Admin', 'User', 'Driver'];

  const getRoles = memberData?.member?.userApplicationDetails?.[0].roles.map((role: any) => {
    return role.roleName;
  });

  const roles = getRoles ? getRoles : mockRoles;

  const firstName = memberData?.member?.firstName;
  const lastName = memberData?.member?.lastName;
  const isRolesArr = roles.length > 0;
  const mainRole = isRolesArr && roles[0];

  return (
    <div className="Manage_Container">
      <div className="Manage_Profile">
        <ProfileCircle name={`${firstName} ${lastName}`} />
        <div className="Manage_Details">
          <p className="Manage_Name">{`${firstName} ${lastName}`}</p>
          <div className={`Roles_Container ${isRolesShow ? 'Expanded' : ''}`}>
            <div className={`${isRolesShow ? 'Expanded_List' : ''}`}>
              <span>{mainRole}</span>
              {isRolesArr && roles.length > 1 && (
                <span className="Roles_Count" onClick={toggleRoles}>
                  {isRolesShow ? '-' : `+ ${roles.length - 1}`}
                </span>
              )}
              {isRolesShow && (
                <ul className="Roles_List">
                  {roles.slice(1).map((role: any, index: any) => (
                    <li key={index}>{role}</li>
                  ))}
                </ul>
              )}
            </div>
            <p className="Manage_Email">{memberData?.member?.email || 'test6@test.com'}</p>
          </div>
        </div>
      </div>
      <ManageMenu />
    </div>
  );
};

export default Manage;
